import { render, staticRenderFns } from "./RbuAdmins.vue?vue&type=template&id=da998df4"
import script from "./RbuAdmins.vue?vue&type=script&lang=js"
export * from "./RbuAdmins.vue?vue&type=script&lang=js"
import style0 from "./RbuAdmins.vue?vue&type=style&index=0&id=da998df4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports